// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__34t81","productName":"Table_productName__2WCvd"};